
import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {deleteFileRga as deleteFileRepo} from '../../../product/shared/repositories';

export const deleteFileRga = (fileToDelete, fileList) =>
    async dispatch => {

        const doesFileExist = fileList.some(item => item.fileName === fileToDelete.fileName && item.serialNumber === fileToDelete.serialNumber);

        if (doesFileExist) {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                await deleteFileRepo(fileToDelete);

            } catch (error) {

            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        }

    };



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/action-creators/delete-file.js